export default __webpack_public_path__ + "static/media/undraw_empty_card.699c8fe4.svg";